const getters = {
  getProjects: state => state.projectList,
  getProjectsWithVirtual: state => state.projectList.concat(state.virtualProjects),
  getJiraProjects: state => state.projectJiraList,
  getSalesChannels: state => state.salesChannelsList
}

const actions = {
  setProjects ({ commit }, data) {
    commit('setProjects', data)
  },
  setJiraProjects ({ commit }, data) {
    commit('setJiraProjects', data)
  },
  setSalesChannels ({ commit }, data) {
    commit('setSalesChannels', data)
  }
}

const mutations = {
  setProjects (state, data) {
    state.projectList = data
  },
  setJiraProjects (state, data) {
    state.projectJiraList = data
  },
  setSalesChannels (state, data) {
    state.salesChannelsList = data
  }
}

const state = {
  projectList: [],
  projectJiraList: [],
  salesChannelsList: [],
  virtualProjects: [
    {
      'key': 'SICK_AND_VACATION',
      'name': 'Sick days and vacations'
    },
    {
      'key': 'WAITING_FOR_TASKS',
      'name': 'Waiting for task'
    },
    {
      'key': 'BENCH',
      'name': 'Bench'
    },
    {
      'key': 'NO_PROJECT',
      'name': 'No project found'
    }
  ]
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
